import * as zod from 'zod';

export const FTPServerState = zod.object({
  kind: zod.literal('FTPServer'),
  connected: zod.boolean().default(false),
  lastOperation: zod.string().optional(),
  error: zod.string().optional(),
});

export type FTPServerState = zod.infer<typeof FTPServerState>;
